export default "__VITE_ASSET__5cMRhBQI__"